import { Nature } from '@mairistem/comptabilite';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import ProjetPanel from '../panel/ProjetPanel';
import SaisieLibrePanel from '../panel/InformationsRattachement/SaisieLibrePanel';

class ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaire extends BaseProfilEcritureDepense {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.DEPENSE.ORDRE_BUDG_SECT_A_SECT_FONCT_AVEC_INFO_INV;
    this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.DEPENSE.FONCTIONNEMENT;
    this.typePiece = TYPE_PIECE.DEPENSE.ORDRE_BUDGET;
    this.imputation.nature = Nature.ORDRE;
    this.imputation.chapitre = '042';
    this.modeDeReglement = [
      MODE_REGLEMENT.DEPENSE.OPERATION_ORDRE,
      MODE_REGLEMENT.DEPENSE.VIREMENT_INTERNE,
    ];
    this.panels = [
      new SaisieLibrePanel(),
      new ProjetPanel(),
      // TODO : add "Marche public" optional panel
    ];
  }
}

export default ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaire;
